import type { UserProfileState, UserProfileStore } from '../domain/types'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { createStore } from 'zustand'

const defaultInitialState: UserProfileState = {
  birthDate: '',
  firstName: '',
  lastName: '',
  birthDateUnformatted: '',
  isAccountDeletable: false,
  isDeleteAlertOpen: false,
  deleteStatus: {
    loading: false,
    error: false,
    success: false,
  },
  retrieveStatus: {
    loading: true,
    error: false,
  },
  saveStatus: {
    loading: false,
    error: false,
    success: false,
  },
  editing: false,
}
export function createUserProfileStore(initialState: UserProfileState = defaultInitialState) {
  return createStore<UserProfileStore>(set => ({
    ...initialState,
    initialize: (state) => {
      set(() => state)
    },

    setFirstName: (firstName: string) => set({ firstName: firstName.trim() }),

    setLastName: (lastName: string) => set({ lastName: lastName.trim() }),

    setBirthDate: (birthDate: string, birthDateUnformatted: string) => set({ birthDate, birthDateUnformatted }),

    setEditing: (editing: boolean) => set(() => ({ editing })),

    setIn: (path, value) => {
      set(state => setIn(state, path, value) as UserProfileState)
    },
  }))
}

export const userProfileStore = createUserProfileStore()
